import { Component, computed, input } from '@angular/core';
import { ChartResultElement } from '@r1-compass-library/models/reporting/chart-data.model';
import { Color, NgxChartsModule } from '@swimlane/ngx-charts';

@Component({
    selector: 'r1-compass-app-counts-bar-chart',
    imports: [NgxChartsModule],
    templateUrl: './counts-bar-chart.component.html',
    styleUrl: './counts-bar-chart.component.scss',
})
export class CountsBarChartComponent {
    results: ChartResultElement[] = [];
    view: [number, number] = [700, 400];
    showXAxis = false;
    showYAxis = true;
    gradient = false;
    showLegend = true;
    xAxisLabel = 'Count';
    showXAxisLabel = false;
    yAxisLabel = 'Date';
    showYAxisLabel = false;
    showDataLabel = true;
    showGridLines = false;
    barPadding = 6;
    colorScheme = computed(() => {
        return {
            domain: this.colors() ?? ['#93d500', '#1174b6', '#ff9933', '#f3b88c'],
        } as unknown as Color;
    });

    colors = input.required<string[]>();

    chartData = input.required<ChartResultElement[]>();
}
